<template>
  <loading v-if="isLoading"></loading>
  <not-found v-else-if="!item"></not-found>
  <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
  <div v-else id="vinc-calculating-detail" class="container-fluid">
    <div class="row o-card__padding-small u-align-items-center">
      <div class="es-xs-12">
        <h4
          class="u-color-primary u-margin-top-small u-margin-bottom u-padding-right-xsmall u-padding-left-xsmall"
        >
          VKS CALCULATION REPORT ( {{ item.title }} )
        </h4>
      </div>
      <div class="es-xs-4">
        <h5 class="u-margin-bottom-xsmall">
          <strong>{{ $t("vincCalculating.potDimensions") }}</strong>
        </h5>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potDiameter") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestPotDiameter }} m
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potHeight") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestPotHeight }} m
          </span>
        </div>
        <h5 class="u-margin-bottom-xsmall u-margin-top">
          <strong>{{ $t("vincCalculating.glassDimensions") }}</strong>
        </h5>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.cabinHeight") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestCabinHeight }} m
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.frontGlassHeight") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestFrontGlassHeight }} m
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.sideGlassHeight") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestSideGlassHeight }} m
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.metalWidth") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestMetalWidth }} m
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.wallThickness") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestWallThickness }} mm
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.insulationThickness") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestInsulationThickness }} mm
          </span>
        </div>
        <h5 class="u-margin-bottom-xsmall u-margin-top">
          <strong>{{ $t("vincCalculating.insulationDimensions") }}</strong>
        </h5>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.outdoorTemperature") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestOutdoorTemperature }} °C
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.cabinTemperature") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.requestCabinTemperature }} °C
          </span>
        </div>
      </div>
      <div class="es-xs-8">
        <img
          :src="require(`@/assets/images/${$i18n.locale}/kabin-pota.png`)"
          width="100%"
          alt="kabin pota"
        />
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom mt-4"
        >
          <span> {{ $t("vincCalculating.totalGlasses") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.totalGlasses }}
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.totalWalls") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.totalWalls }}
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.cabinTotalThermalLoad") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ item.cabinTotalThermalLoad }}
          </span>
        </div>
      </div>
      <div class="es-xs-6 u-margin-top">
        <h5 class="u-margin-bottom-xsmall">
          <strong>{{ $t("vincCalculating.automaticValues") }}</strong>
        </h5>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potaKabinYatayUzaklik") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.potaKabinYatayUzaklik }} m
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potaKabinYukseklik") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.potaKabinYukseklik }} m
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potaYuzeyiSicakligi") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.potaYuzeyiSicakligi }} °C
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potaYuzeyiYaymaOrani") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.potaYuzeyiYaymaOrani }}
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potaYanYuzeySicakligi") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.potaYanYuzeySicakligi }} °C
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.potaYanYuzeyYaymaOrani") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.potaYanYuzeyYaymaOrani }}
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.yalitimliAlanOrani") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.yalitimliAlanOrani }}
          </span>
        </div>
      </div>
      <div class="es-xs-6 u-margin-top">
        <h5 class="u-margin-bottom-xsmall">
          <strong>{{ $t("vincCalculating.automaticValues") }}</strong>
        </h5>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.disOrtamTasinimKatsayisi") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.disOrtamTasinimKatsayisi }} W/m2K
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span>
            {{ $t("vincCalculating.kabinOrtamiTasinimKatsayisi") }}:
          </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.kabinOrtamiTasinimKatsayisi }} W/m2K
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.duvarYaymaOrani") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.duvarYaymaOrani }}
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.duvarGecirmeOrani") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.duvarGecirmeOrani }}
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.metalSacIsiIletimKatsayisi") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.metalSacIsiIletimKatsayisi }} W/m.K
          </span>
        </div>
        <div
          class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom"
        >
          <span> {{ $t("vincCalculating.tasYunu") }}: </span>
          <span class="u-amrgin-left-xsmall">
            {{ automaticValues.tasYunu }} W/m.K
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Loading from "../../Base/Loading/Loading.vue";
import NotFound from "../../Base/NotFound.vue";
import html2pdf from "html2pdf.js";
import authorize from "../EhouseCalculating/authorize";
export default {
  components: { Loading, NotFound },
  mixins: [authorize],
  data() {
    return {
      cycleId: null,
      isLoading: true,
      cycle: null,
      creatingPdf: false,
      automaticValues: {
        potaKabinYatayUzaklik: 10,
        potaKabinYukseklik: 15,
        potaYuzeyiSicakligi: 1473.15,
        potaYuzeyiYaymaOrani: 0.8,
        potaYanYuzeySicakligi: 973.15,
        potaYanYuzeyYaymaOrani: 0.9,
        yalitimliAlanOrani: 0.8,
        disOrtamTasinimKatsayisi: 30,
        kabinOrtamiTasinimKatsayisi: 25,
        duvarYaymaOrani: 0.8,
        duvarGecirmeOrani: 0,
        metalSacIsiIletimKatsayisi: 54,
        tasYunu: 0.042,
      },
      item: {
        requestPotDiameter: 5,
        requestPotHeight: 4,
        requestFrontGlassHeight: 4,
        requestSideGlassHeight: 4,
        requestMetalWidth: 4,
        requestOutdoorTemperature: 4,
        requestCabinTemperature: 4,
        requestWallThickness: 4,
        requestInsulationThickness: 4,
        requestCabinHeight: 4,
        totalGlasses: -0.104,
        totalWalls: -15.398,
        cabinTotalThermalLoad: -15.502,
      },
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    result: {
      type: Object,
      required: true,
    },
    autoPrint: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setForm() {
      this.item = {
        title: this.title || this.$t("vincCalculating.mainTitle"),
        requestPotDiameter: this.form.potDiameter,
        requestPotHeight: this.form.potHeight,
        requestFrontGlassHeight: this.form.frontGlassHeight,
        requestSideGlassHeight: this.form.sideGlassHeight,
        requestMetalWidth: this.form.metalWidth,
        requestOutdoorTemperature: this.form.outdoorTemperature,
        requestCabinTemperature: this.form.cabinTemperature,
        requestWallThickness: this.form.wallThickness,
        requestInsulationThickness: this.form.insulationThickness,
        requestCabinHeight: this.form.cabinHeight,
        totalGlasses: this.result.totalGlasses,
        totalWalls: this.result.totalWalls,
        cabinTotalThermalLoad: this.result.cabinTotalThermalLoad,
      };
      this.isLoading = false;
      this.createPdf();
    },
    async getItem() {
      if (this.autoPrint) return this.setForm();
      this.isLoading = true;
      const response = await Requests.CraneHVACC.GetById({
        params: {
          id: this.$route.params.id,
        },
      });
      if (response.message === "OK") {
        this.item = response.data;
        this.createPdf();
      }
      this.isLoading = false;
    },
    async createPdfBlob() {
      const element = document.getElementById("vinc-calculating-detail");
      const opt = {
        margin: [25, 1, 40, 1],
        filename: this.item.title + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      const footerImg = "/pdf-footer.png";
      const headerImg = "/pdf-header.png";
      //const footerLogo = ;
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.addImage(
              footerImg,
              "png",
              10,
              pdf.internal.pageSize.getHeight() - 30,
              pdf.internal.pageSize.getWidth() - 20,
              30
            );
            pdf.addImage(
              headerImg,
              "png",
              10,
              0,
              pdf.internal.pageSize.getWidth() - 20,
              25
            );
            // pdf.addImage(
            //   footerLogo,
            //   "png",
            //   0,
            //   0,
            //   pdf.internal.pageSize.getWidth(),
            //   0.3
            // );
          }
          window.open(pdf.output("bloburl"), "_blank");
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: false,
          });
          this.creatingPdf = false;
          this.$emit("pdfCreated");
        });
      return "";
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
    async createPdf() {
      this.creatingPdf = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.creatingPdf"),
        duration: 20 * 60 * 1000,
      });
      setTimeout(async () => {
        await this.createPdfBlob();
      }, 500);
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>

<style scoped>
page {
  background: white;
  display: block;
  margin: 0 auto;
  position: relative;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}

.page_header {
  position: running(header);
  width: 100%;
}

.page_footer {
  position: running(footer);
  width: 100%;
}

.pdf-content {
  padding: 20px;
}
</style>
